// Pure geometry and timing for Shingan's effects (shingan-fx.ts), kept free of Pixi and the DOM so tests can check them.
import { CONFIG, CITY_ART } from '../../common/src/data';

/** Decoy shimmer: every `gap` seconds (phase set by the id) a decoy slips 1 px sideways for a tenth of a second with a
 *  light band crossing it. `on` is false the rest of the time: at rest a decoy is drawn exactly like him. */
export function decoyShimmer(t: number, id: number, gap = CITY_ART.shinganFx.shimmerGapSec) {
  const phase = ((t + (id * 0.618) % 1 * gap) % gap) / gap, on = phase < 0.1 / gap;
  return { on, dx: on ? (id % 2 ? 1 : -1) : 0, band: on ? phase * gap / 0.1 : 0 };
}
/** The wind-up telegraph's wedge: the server's sweep reach and arc (config sanctuary.boss.melee) around his facing,
 *  which the server freezes for the wind-up, so the warned area is the area the sweep hits. */
export function telegraphWedge(x: number, y: number, a: number) {
  const M = CONFIG.sanctuary.boss.melee; return { x, y, r: M.reach, a0: a - M.arc / 2, a1: a + M.arc / 2 };
}
/** does the wedge cover (px, py)? (the same test as sanctuary.ts sweep: distance, then the half-arc) */
export function inWedge(w: ReturnType<typeof telegraphWedge>, px: number, py: number) {
  if (Math.hypot(px - w.x, py - w.y) > w.r) return false;
  const mid = (w.a0 + w.a1) / 2, d = Math.atan2(Math.sin(Math.atan2(py - w.y, px - w.x) - mid), Math.cos(Math.atan2(py - w.y, px - w.x) - mid));
  return Math.abs(d) <= (w.a1 - w.a0) / 2;
}
